import { render, staticRenderFns } from "./VideoSingle.vue?vue&type=template&id=1d960b72&"
import script from "./VideoSingle.vue?vue&type=script&lang=js&"
export * from "./VideoSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports